<div class="content">
  @if (loaded) {
    <div class="content-body">
      <div class="left">
        <!-- TODO find Material styling -->
        <div class="imageContainer">
          @if (
            organization.profileImageUrl !== null && file == undefined) {
            <img
              class="image"
              [src]="apiBase + organization.profileImageUrl | secure | async"
              alt=""
              />
          } @else {
            <img class="image" [src]="currentProfileImageUrl" />
          }
          <button
            mat-mini-fab
            class="edit"
            color="buttonSuccess"
            (click)="file_input.click()"
            >
            <mat-icon matTooltip="Update">edit</mat-icon>
          </button>
          <input
            type="file"
            #file_input
            (change)="onFileChange(file_input.files)"
            class="hidden-file-input"
            accept=".jpg,.png,.jpeg,.jfif"
            />
        </div>
        <div class="updateForm">
          <mat-form-field appearance="outline" class="formField">
            <mat-label>Name</mat-label>
            <input [formControl]="nameFormControl" type="text" matInput />
            @if (false) {
              <mat-error> Name is required. </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" color="primary" class="formField">
            <mat-label>Shopify Domain</mat-label>
            <input [formControl]="shopifyFormControl" type="text" matInput />
            @if (organization.lastSyncedAt != null) {
              <mat-hint>
                Last Synced on {{ organization.lastSyncedAt }}
              </mat-hint>
            }
            <button
              mat-icon-button
              matSuffix
              (click)="shopifyLogin()"
              [disabled]="shopifyFormControl.untouched"
              >
              <mat-icon>sync</mat-icon>
            </button>
          </mat-form-field>
          @if (requestInProgress) {
            <mat-progress-spinner [mode]="'indeterminate'">
            </mat-progress-spinner>
          }
        </div>
      </div>
      <div class="right">
        <h1 class="title">Output Formats Configuration</h1>
          <div class="output-setting">
            </div>
            <mat-divider class="section-divider"></mat-divider>
            <app-product-data-filename-convention-card
              [organizationId]="organization.id!"
            ></app-product-data-filename-convention-card>
            <mat-divider class="section-divider"></mat-divider>
            <app-output-composition-card
              [organizationId]="organization.id!"
            ></app-output-composition-card>
            <mat-divider class="section-divider"></mat-divider>
            <h1 class="title">Data Convention</h1>
            @if (hasPriorConvention && currentDataConvention !== null) {
              <div class="data-convention-details">
                <div class="detail-row">
                  <span class="detail-label">Dimensions order</span>
                  <span class="detail-value">{{ dimensionOrderLabel(currentDataConvention.dimensionOrder) }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Dimension unit</span>
                  <span class="detail-value">{{ currentDataConvention.dimensionUnit }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Weight unit</span>
                  <span class="detail-value">{{ currentDataConvention.weightUnit }}</span>
                </div>
                <button
                  mat-icon-button
                  color="buttonSuccess"
                  class="data-convention-button"
                  aria-label="Update data convention"
                  (click)="openDataConventionDialog()"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            } @else {
              <div class="data-convention-details data-convention-example">
                <div class="detail-row">
                  <span class="detail-label">Dimensions order</span>
                  <span class="detail-value"></span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Dimension unit</span>
                  <span class="detail-value"></span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Weight unit</span>
                  <span class="detail-value"></span>
                </div>
                <button
                  mat-stroked-button
                  color="buttonSuccess"
                  class="data-convention-button"
                  (click)="openDataConventionDialog()"
                >
                  Create
                </button>
              </div>
            }
          </div>
        </div>
      }
      <div class="content-actions">
        <span class="spacer"></span>
        <button mat-stroked-button (click)="goBack()" style="margin-right: 10px">
          Cancel
        </button>
        <button
          (click)="updateOrganization()"
          color="buttonSuccess"
          [disabled]="!nameFormControl.valid || !shopifyFormControl.valid"
          mat-button
          >
          Save
        </button>
      </div>
    </div>
